import React, {Fragment} from "react";
import { connect } from "react-redux";
import {getCurrentLayout} from "../../appLayout";
import {
  getPriceWithCurrency,
  getRoomName,
  getTotalPrice,
  toFixedPrice,
  getSlabsFeatureGroup
} from "../../../misc/helpers";
import AdvancedQuotingSubpartItems from "./advancedQuotingSubpartItems";
import {FormattedMessage, injectIntl} from "react-intl";
import SimilarProducts from "../similarProducts/similarProducts";
import {getCurrentQuoteRoomName, getRoomCartItemForCategoryName} from "../../../misc/categorySwitchingFunctions";
import {showWizardInsteadOfQT} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import AdvancedQuotingWizard from "./advancedQuotingWizard/advancedQuotingWizard";

const AdvancedQuotingList = (props) => {

  const {quotes, cartItems, activeQuoteIndex, showAllQuotesCartItemsList, intl, fabricatorData, wizardList, wizardIsActive} = props;
  const fabricatorSettings = fabricatorData.settings;

  return quotes.map((quote, quoteIndex) => {

    const layout = getCurrentLayout(fabricatorSettings.allowVisualizerSwitching && quote.room ? quote.room : document.kvConfig.visualizerType);

    if ((quoteIndex !== activeQuoteIndex) && !showAllQuotesCartItemsList) {
      return null
    }
    const quoteTotalPrice = getTotalPrice(quoteIndex, false);

    const otherCartItems = cartItems.filter(cartItem => {
      const isSlabsCartItem = cartItem.partId === 'slabs';
      return layout.qtCategories
        && cartItem.cartFeature
        && (cartItem.currentQuote === quoteIndex)
        && !isSlabsCartItem
        && !cartItem.bundleParentId
        && !layout.qtCategories.some(qtCat => qtCat.subParts.some(sPart => {
          return sPart.part.partId === cartItem.partId
        }))
    });

    const slabCartItems = cartItems.filter(cartItem => {
      const isSlabsCartItem = cartItem.partId === 'slabs';
      return layout.qtCategories
        && cartItem.cartFeature
        && (cartItem.currentQuote === quoteIndex)
        && !cartItem.bundleParentId
        && isSlabsCartItem
        && !layout.qtCategories.some(qtCat => qtCat.subParts.some(sPart => {
          return sPart.part.partId === cartItem.partId
        }))
    });

    const selectedQuoteRoomName = getCurrentQuoteRoomName(cartItems, quoteIndex);
    // console.log("selectedQuoteRoomName", selectedQuoteRoomName);
    const qtCategories = layout.qtCategories;

    return (
      <div className={"scart-block scart-room" + (showAllQuotesCartItemsList ? " scart-room--bordered" : "")} key={quoteIndex}>
        {showAllQuotesCartItemsList ? (
          <h4 className="scart-block__title-room">
            <FormattedMessage id="shoppingCart.roomTitle"/>: {getRoomName(quoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData)}
          </h4>
        ) : null}
        {showWizardInsteadOfQT(wizardList, wizardIsActive)
          ? <AdvancedQuotingWizard quoteIndex={quoteIndex}/>
          : layout.qtCategories ? (
          <Fragment>
            {qtCategories.map(qtCategory => {
              let currentRoomName = "";
              if (fabricatorSettings.useCategorySwitching) {
                currentRoomName = qtCategory.name.trim().toLowerCase();
                // console.log("currentRoomName", currentRoomName);
              }
              return qtCategory.subParts.map((subPart, subPartIndex) => {
                if (fabricatorSettings.useCategorySwitching && ((subPart.part.partId !== "room") && (currentRoomName !== selectedQuoteRoomName))) {
                  if (getRoomCartItemForCategoryName(currentRoomName, fabricatorSettings)) { // this checks if room is available for current category
                    return null
                  }
                }
                let advancedCartItems = cartItems.filter(cartItem => {
                  if (cartItem.bundleParentId) {
                    return false
                  }
                  return cartItem.cartFeature && (cartItem.currentQuote === quoteIndex) && (subPart.part.partId === cartItem.partId)
                      && (!cartItem.fromQtCategory || (cartItem.fromQtCategory === qtCategory.name)) // !cartItem.fromQtCategory added just in case. it should always be
                });

                return <AdvancedQuotingSubpartItems subPart={subPart}
                                                    advancedCartItems={advancedCartItems}
                                                    quoteIndex={quoteIndex}
                                                    key={quoteIndex + subPartIndex}
                                                    qtCategoryName={qtCategory.name}/>
              })
            })}
            {otherCartItems.length ? (
              <AdvancedQuotingSubpartItems subPart={{
                part: {
                  partId: "other_related_products",
                  partName: intl.formatMessage({id: "assignPopup.otherFeatureGroupName"})}
              }}
                                           advancedCartItems={otherCartItems}
                                           quoteIndex={quoteIndex}/>
            ) : null}
            {fabricatorSettings.showSlabMode ? (
              <AdvancedQuotingSubpartItems subPart={getSlabsFeatureGroup()}
                                           advancedCartItems={slabCartItems}
                                           quoteIndex={quoteIndex}/>
            ) : null}
          </Fragment>
        ) : null}
        {showAllQuotesCartItemsList ? (
          <div className="scart-block__subtotal">
            <span className="scart-block__subtotal-text"><FormattedMessage id="advancedQuoting.subTotal"/></span>
            {getPriceWithCurrency(fabricatorSettings, toFixedPrice(quoteTotalPrice.materialPrice))}
          </div>
        ) : null}
        <SimilarProducts quoteIndex={+quoteIndex} />
      </div>
    )
  });
};

const mapStateToProps = (store) => {
  const {wizardList, wizardIsActive} = store.wizardState;
  const {visualizerIsChanging} = store.serverState;
  return {
    cartItems: store.cartState.cartItems,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    quotes: store.quotesState.quotes,
    showAllQuotesCartItemsList: store.cartState.showAllQuotesCartItemsList,
    fabricatorData: store.fabricatorState,
    wizardList,
    wizardIsActive,
    visualizerIsChanging,
  };
};

const mapDispatchToProps = {

};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AdvancedQuotingList)
)
